/* The theme's footer clock hardcodes NYC and rewrites itself every 30s.
   Watch it and relabel to Raleigh. Same timezone, so the time stays correct. */
(function () {
  function boot() {
    var clock = document.getElementById('clock');
    if (!clock) return;
    function fix() {
      if (clock.textContent.indexOf('NYC') !== -1) {
        clock.textContent = clock.textContent.replace('NYC', 'Raleigh');
      }
    }
    new MutationObserver(fix).observe(clock, {
      childList: true, characterData: true, subtree: true
    });
    fix();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
